import { BaseAPI, OnRequestChangeCallback } from 'services/APIs/BaseAPI'
import {
  IAnalyticsAPI,
  SalesLeadTimeDataset,
  ConvertionRateDataset,
  KPI,
} from './SalesLeadTimeController'
import { QuantityDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { KPITargetConfiguration } from 'components/Dashboard/DashboardWidget'

export class AnalyticsAPI extends BaseAPI implements IAnalyticsAPI {
  constructor(private onRequestChange: OnRequestChangeCallback) {
    super(process.env.REACT_APP_ANALYTICS_API_BASE_URL)
  }
  public async GetSalesLeadTime(
    organizationId: string,
    startDate: string,
    endDate: string,
    fromStatus: string,
    toStatus: string
  ) {
    const fixFromStatus = fromStatus.charAt(0)
      ? fromStatus.charAt(0).toUpperCase()
      : ''

    const fixToStatus = toStatus.charAt(0)
      ? toStatus.charAt(0).toUpperCase()
      : ''

    return await this.GetAsync<Array<SalesLeadTimeDataset>>({
      id: 'get-sales-lead-time',
      relativePath: `/parties/${organizationId}/projects/leadtime`,
      params: {
        startDate,
        endDate,
        fromStatus: fixFromStatus + fromStatus.slice(1),
        toStatus: fixToStatus + toStatus.slice(1),
      },
      onRequestChange: (req) =>
        this.onRequestChange(
          this.OnRequestChangeWithId('get-sales-lead-time', req)
        ),
    })
  }

  public async GetConversionRate(
    organizationId: string,
    startDate: string,
    endDate: string
  ) {
    return await this.GetAsync<ConvertionRateDataset>({
      id: 'get-convertion-rate',
      relativePath: `/parties/${organizationId}/projects/conversion`,
      params: {
        startDate,
        endDate,
      },
      onRequestChange: (req) =>
        this.onRequestChange(
          this.OnRequestChangeWithId('get-convertion-rate', req)
        ),
    })
  }

  public async GetKPIConfigurations(organizationId: string) {
    return await this.GetAsync<Array<KPITargetConfiguration>>({
      id: 'get-kpi-configurations',
      uri: `${process.env.REACT_APP_API_BASE_URL}/api/parties/${organizationId}/analytics/configurations`,
      relativePath: undefined,
    })
  }

  public async SetKPITarget(
    organizationId: string,
    kpi: KPI,
    value: QuantityDto
  ) {
    return await this.PutAsync<void>({
      id: `set-kpi-configuration-${kpi}`,
      uri: `${process.env.REACT_APP_API_BASE_URL}/api/parties/${organizationId}/analytics`,
      data: {
        kpi: kpi,
        value: value,
      },
      relativePath: undefined,
    })
  }
}
